module.exports = __webpack_public_path__ + "img/simplepay_logo.db60063b.png";